<app-base-dialog sizeClass="size-25" [topBarTemplate]="topBar" [bottomBarRightTemplate]="bottomBar">
	<ng-template #topBar>
		<app-dialog-header [title]="titel"></app-dialog-header>
	</ng-template>
	<div class="control">
		<div class="label">Opmerking</div>
		<textarea autofocus [(ngModel)]="tekst" (keydown)="keyDown($event)"></textarea>
	</div>
	<ng-template #bottomBar>
		<app-button buttonType="secondary" (clickit)="dialogRef.close()">Annuleren</app-button>
		<app-button (clickit)="opslaan()">Opslaan</app-button>
	</ng-template>
</app-base-dialog>
